module.exports = __webpack_public_path__ + "static/media/MallHogar.b8857d57.jpg";